import { useQuery } from '@apollo/client';

import { BUSINESS_QUERY } from '@monolith/queries/business';

export const useBusinessQuery = (businessName: string | undefined) =>
    useQuery(BUSINESS_QUERY, {
        variables: { businessName },
        skip: !businessName,
    });
